/* StoneAudio theme.js — cart drawer, hero carousel, mega-menu, tabs */
(function () {
  'use strict';

  /* ── Cart drawer ────────────────────────────────────────── */
  function initCartDrawer() {
    const drawer  = document.querySelector('.cart-drawer');
    const overlay = document.querySelector('.cart-drawer__overlay');
    const closeBtn = document.querySelector('.cart-drawer__close');
    const cartBtns = document.querySelectorAll('[data-open-cart]');

    if (!drawer) return;

    function open()  { drawer.classList.add('is-open'); overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function close() { drawer.classList.remove('is-open'); overlay.classList.remove('is-open'); document.body.style.overflow = ''; }

    cartBtns.forEach(btn => btn.addEventListener('click', open));
    closeBtn?.addEventListener('click', close);
    overlay?.addEventListener('click', close);

    document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
  }

  /* ── Hero carousel ──────────────────────────────────────── */
  function initHeroCarousel() {
    const carousel = document.querySelector('.hero-carousel');
    if (!carousel) return;

    const slides = carousel.querySelectorAll('.hero-carousel__slide');
    const dots   = carousel.querySelectorAll('.hero-carousel__dot');
    if (slides.length < 2) return;

    let current = 0;
    let timer;

    function goTo(idx) {
      slides[current].classList.remove('is-active');
      dots[current]?.classList.remove('is-active');
      current = (idx + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      dots[current]?.classList.add('is-active');
    }

    function startTimer() {
      timer = setInterval(() => goTo(current + 1), 5000);
    }

    function resetTimer() { clearInterval(timer); startTimer(); }

    dots.forEach((dot, i) => dot.addEventListener('click', () => { goTo(i); resetTimer(); }));
    carousel.querySelector('.hero-carousel__arrow--next')?.addEventListener('click', () => { goTo(current + 1); resetTimer(); });
    carousel.querySelector('.hero-carousel__arrow--prev')?.addEventListener('click', () => { goTo(current - 1); resetTimer(); });

    startTimer();
  }

  /* ── Product image gallery tabs ─────────────────────────── */
  function initProductGallery() {
    const thumbs = document.querySelectorAll('.product-gallery__thumb');
    const mainImg = document.querySelector('.product-gallery__main img');
    if (!thumbs.length || !mainImg) return;

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        thumbs.forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        const src = thumb.dataset.src;
        if (src) mainImg.src = src;
      });
    });
  }

  /* ── Tabs (product page) ────────────────────────────────── */
  function initTabs() {
    document.querySelectorAll('.tab-nav').forEach(nav => {
      const btns   = nav.querySelectorAll('.tab-btn');
      const panels = nav.closest('.product-info__tabs')?.querySelectorAll('.tab-panel') ||
                     nav.parentElement?.querySelectorAll('.tab-panel');
      if (!panels?.length) return;

      btns.forEach((btn, i) => {
        btn.addEventListener('click', () => {
          btns.forEach(b => b.classList.remove('is-active'));
          panels.forEach(p => p.classList.remove('is-active'));
          btn.classList.add('is-active');
          panels[i]?.classList.add('is-active');
        });
      });
    });
  }

  /* ── Mobile menu ────────────────────────────────────────── */
  function initMobileMenu() {
    const hamburger = document.querySelector('.site-header__hamburger');
    const menu      = document.querySelector('.mobile-menu');
    const overlay   = menu?.querySelector('.mobile-menu__overlay');
    const closeBtn  = menu?.querySelector('.mobile-menu__close');

    if (!hamburger || !menu) return;

    function open()  { menu.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function close() { menu.classList.remove('is-open'); document.body.style.overflow = ''; }

    hamburger.addEventListener('click', open);
    overlay?.addEventListener('click', close);
    closeBtn?.addEventListener('click', close);
  }

  /* ── Search overlay ─────────────────────────────────────── */
  function initSearch() {
    const searchBtns = document.querySelectorAll('[data-open-search]');
    const overlay    = document.querySelector('.search-overlay');
    const input      = overlay?.querySelector('.search-overlay__input');
    const closeBtn   = overlay?.querySelector('.search-overlay__close');

    if (!overlay) return;

    function open()  { overlay.classList.add('is-open'); input?.focus(); }
    function close() { overlay.classList.remove('is-open'); }

    searchBtns.forEach(btn => btn.addEventListener('click', open));
    closeBtn?.addEventListener('click', close);
    overlay.addEventListener('click', e => { if (e.target === overlay) close(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
  }

  /* ── Cart quantity steppers ─────────────────────────────── */
  function initQtySteppers() {
    document.querySelectorAll('.cart-item__qty').forEach(row => {
      const val     = row.querySelector('.cart-item__qty-val');
      const minus   = row.querySelector('[data-qty-minus]');
      const plus    = row.querySelector('[data-qty-plus]');
      if (!val) return;
      minus?.addEventListener('click', () => {
        const n = Math.max(1, parseInt(val.textContent || '1', 10) - 1);
        val.textContent = n;
      });
      plus?.addEventListener('click', () => {
        const n = parseInt(val.textContent || '1', 10) + 1;
        val.textContent = n;
      });
    });
  }

  /* ── Init all ───────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', () => {
    initCartDrawer();
    initHeroCarousel();
    initProductGallery();
    initTabs();
    initMobileMenu();
    initSearch();
    initQtySteppers();
  });
})();
